import { 
  HiOutlineViewGrid, 
  HiOutlineDatabase,
  HiOutlineServer,
  HiOutlineChartBar,
  HiOutlineClock
} from 'react-icons/hi';
import { SERIES_LIST } from '../model/UnitSeries';
import { getAllTMSModels } from '../TMS/config/tmsModels'; // TMSモデル管理をインポート

export const sidebarConfig = {
  title: 'Chowa Dashboard',
  menuItems: [
    {
      path: 'main',
      name: 'Dashboard',
      icon: HiOutlineViewGrid
    },
    {
      path: 'time-monitoring',
      name: '時間監視',
      icon: HiOutlineClock,
      subItems: SERIES_LIST.map(series => ({
        path: series.key.toLowerCase(),
        name: series.name,
        icon: HiOutlineChartBar,
        series: series.key
      }))
    },
    {
      path: 'tms',  // TMSメインメニュー
      name: 'TMS',
      icon: HiOutlineServer,  // 通常のReact-iconsアイコン
      subItems: getAllTMSModels().map(model => ({  // 動的生成
        path: model.id,          // tms000, tms001
        name: model.displayName, // TMS#000, TMS#001
        icon: HiOutlineDatabase
      }))
    },
    // {
    //   path: '/download',  // ルートパスから始まるパスを指定
    //   name: 'ダウンロード',
    //   icon: HiOutlineDownload,
    //   external: true  // 外部リンクとしてマーク
    // }
  ]
};
